import Loader from '@/components/common/Loader'
import { useHubspotForm } from 'next-hubspot'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const BookNow = () => {
  // Use the hook directly (not inside useEffect)
  const [loading, setLoading] = useState(true)
  const router = useRouter()
  const { loaded, error, formCreated } = useHubspotForm({
    portalId: '46037834',
    formId: 'd5b25329-386d-4548-99b0-659d5f9c189d',
    target: '#hubspot-form-wrapper',
  })

  useEffect(() => {
    const handleOnLoadingForms = (event) => {
      setLoading(false)
    }

    const handleSubmissionSuccess = async (event) => {
      setLoading(false)
      router.push('/book-now/confirmation')
    }
    // Attach event listener
    window.addEventListener('hs-form-event:on-ready', handleOnLoadingForms)
    window.addEventListener('hs-form-event:on-submission:success', handleSubmissionSuccess)
    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('hs-form-event:on-ready', handleOnLoadingForms)
      window.removeEventListener('hs-form-event:on-submission:success', handleSubmissionSuccess)
    }
  }, [])

  return (
    <>
      {loading && <Loader />}
      <div className="w-full md:w-1/2 mx-auto" id="hubspot-form-wrapper"></div>
    </>
  )
}

export default BookNow
